export { default } from './TiraMobile';
